<template>
    <div>
        <div class="resourceServiceDirectory-title">
            <div>{{$t('resourceLifecycle.resourceServiceDirectory')}}</div>
        </div>
        <div class="resourceServiceDirectory-top">
            <resource-service-directory-search></resource-service-directory-search>
        </div>
        <table-resource-service-directory></table-resource-service-directory>
    </div>
</template>

<script>
    import ResourceServiceDirectorySearch from '../resource_service_directory/ResourceServiceDirectorySearch'
    import TableResourceServiceDirectory from '../resource_service_directory/TableResourceServiceDirectory'

    export default {
        name: 'ResourceServiceDirectory',
        components: {
            ResourceServiceDirectorySearch,
            TableResourceServiceDirectory
        }
    }
</script>

<style scoped>
    .resourceServiceDirectory-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .resourceServiceDirectory-title>div:nth-child(1)
    {
        float:left;
    }
    .resourceServiceDirectory-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_directory/ResourceServiceDirectory.vue